import {BaseApiRequestParams} from "../../../infrastructure/models/params/base-api-request-params";

export class NewsRequestParams extends BaseApiRequestParams {
  sports: Array<Number>;
  countries: Array<Number>;
  competitions: Array<Number>;
  competitors: Array<Number>;
  games: Array<Number>;
  userCompetitions: Array<Number>;
  userCompetitors: Array<Number>;

  constructor(sports: Array<Number>, countries: Array<Number>, competitions: Array<Number>, competitors: Array<Number>, games: Array<Number>,
              athletes: Array<Number>, userCompetitions: Array<Number>, userCompetitors: Array<Number>, isPreview: Boolean = false) {
    super('news/');

    this.sports = sports;
    this.countries = countries;
    this.competitions = competitions;
    this.competitors = competitors;
    this.games = games;
    this.athletes = athletes;
    this.userCompetitions = userCompetitions;
    this.userCompetitors = userCompetitors;
    this.isPreview = isPreview;
  }

  get sportsParam() {
    return this.sports && this.sports.length > 0 ? `&sports=${this.sports.toString()}` : '';
  }

  get countriesParam() {
    return this.countries && this.countries.length > 0 ? `&countries=${this.countries.toString()}` : '';
  }

  get competitionsParam() {
    return this.competitions && this.competitions.length > 0 ? `&competitions=${this.competitions.toString()}` : '';
  }

  get competitorsParam() {
    return this.competitors && this.competitors.length > 0 ? `&competitors=${this.competitors.toString()}` : '';
  }

  get gamesParam() {
    return this.games && this.games.length > 0 ? `&games=${this.games.toString()}` : '';
  }

  get athletesParam() {
    return this.athletes && this.athletes.length > 0 ? `&athletes=${this.athletes.toString()}` : '';
  }

  get userCompetitionsParam() {
    return this.userCompetitions && this.userCompetitions.length > 0 ? `&userCompetitions=${this.userCompetitions.toString()}` : '';
  }

  get userCompetitorsParam() {
    return this.userCompetitors && this.userCompetitors.length > 0 ? `&userCompetitors=${this.userCompetitors.toString()}` : '';
  }

  get isPreviewParam() {
    return `&isPreview=${this.isPreview}` ;
  }


  toString(): string {
    return super.toString() + this.sportsParam + this.countriesParam + this.competitionsParam + this.competitorsParam +
        this.gamesParam + this.athletesParam + this.userCompetitionsParam + this.userCompetitorsParam + this.isPreviewParam;
  }

  equals(model: NewsRequestParams): Boolean {
    let equals = super.equals(model);


    equals &= this.sportsParam === model.sportsParam;
    equals &= this.countriesParam === model.countriesParam;
    equals &= this.competitionsParam === model.competitionsParam;
    equals &= this.competitorsParam === model.competitorsParam;
    equals &= this.gamesParam === model.gamesParam;
    equals &= this.athletesParam === model.athletesParam;
    equals &= this.userCompetitionsParam === model.userCompetitionsParam;
    equals &= this.userCompetitorsParam === model.userCompetitorsParam;
    equals &= this.isPreviewParam === model.isPreviewParam;

    return equals;
  }
}
